/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { VodPlayActionError } from '../../../core/error';
import { Locale, LocaleKeys } from '../../../core/locale';
import { ScreenTaskControllerTypes } from '../../../core/navigation';
import { hideOverlayDialog, showOverlayDialog } from '../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../overlaydialog/overlaydialogprops';
import { setScreenTaskController } from '../../screens/screens.reducers';

const GLOBAL_MOUSE_TRAP: string = 'HideVodPlayErrorOverlay';

export const showVodPlayErrorOverlay = (error: VodPlayActionError) => (dispatch: Function) => {
    const overlayOptions = [{ text: Locale.getString(LocaleKeys.OVERLAY_OPTION_OK_TEXT) }];
    const overlayDialogProps: IOverlayDialog = {
        description: error.getDescription(),
        hasDimmer: true,
        hasSeperator: false,
        messageCode: error.getCode(),
        mouseTrapValue: GLOBAL_MOUSE_TRAP,
        options: overlayOptions,
        title: error.getTitle(),
    };
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.VOD_PLAY_ERROR_OVERLAY));
    dispatch(showOverlayDialog(overlayDialogProps));
};

export const onKeyOkVodPlayErrorOverlay = () => (dispatch: Function) => {
    // add logs if required
    dispatch(hideOverlayDialog());
};

export const onKeyBackVodPlayErrorOverlay = () => (dispatch: Function) => {
    // add logs if required
    dispatch(hideOverlayDialog());
};

export const onMouseClickVodPlayErrorOverlay = () => (dispatch: Function, getState: Function) => {
    // add logs if required
    const { value } = getState().inputFactory;

    if (value === GLOBAL_MOUSE_TRAP) {
        dispatch(hideOverlayDialog());
        return;
    }
    dispatch(onKeyOkVodPlayErrorOverlay());
};
